import { Component, OnInit } from '@angular/core';
import { CompanyService, SharedService, Toaster } from '@app/services';
import { Company } from '@app/models';
import { LocalStorage } from 'ngx-webstorage';
import { SelectBox, ClientCompany } from '../../../models';
import { ClientCompanyService } from '@services/client-company.service';

@Component({
  selector: 'ngx-my-company-details',
  templateUrl: './my-company-details.component.html',
})
export class MyCompanyDetailsComponent implements OnInit {
  @LocalStorage() organizationId: string;
  company: Company = new Company();
  loading: boolean = false;
  governmentTypes: any = [];
  priorities: SelectBox[];
  clientCompanies: ClientCompany[] = [];
  clientCompaniesDisplayedColumns = ['client_organization_name', 'primary_contact_name'];

  constructor(
    private $clientCompany: ClientCompanyService,
    private $company: CompanyService,
    private $shared: SharedService,
    private $toaster: Toaster) {
    this.getCompany(this.organizationId);
    this.getPrimaryContacts();
  }

  ngOnInit() {
    this.governmentTypes = this.$shared.taxTypes();
    this.priorities = this.$shared.priorities();
  }

  async getCompany(id: string) {
    this.loading = true;
    this.$company.getById(id).subscribe(
      company => {
        this.loading = false;
        this.company = company;
      },
      error => {
        console.error('ERROR Fetching Company', error);
        this.$toaster.show('error', 'Error', 'Error loading the company details');
      },
    );
  }

  async getPrimaryContacts() {
    this.$clientCompany.getAllClientCompanies().subscribe(clients => {
      this.clientCompanies = clients.sort((a, b) => {
        if (a.organization_name > b.organization_name)
          return 1;
        else if (a.organization_name < b.organization_name)
          return -1;
        return 0;
      });
    });
  }

  onDeleteConfirm(event): void {
    if (window.confirm('Are you sure you want to delete?')) {
      event.confirm.resolve();
    } else {
      event.confirm.reject();
    }
  }

  update() {
    this.loading = true;
    this.company.government_id_type = +this.company.government_id_type;
    this.$company.updateCompany(this.company).subscribe(null, error => {
      const errorMsg = error.error ? error.error.details : 'Error updating the company details';
      this.$toaster.show('error', 'Error', errorMsg);
      console.error(error);
    });
  }

  getContactFullName(client: ClientCompany): string {
    return `${client.primary_contact.first_name} ${client.primary_contact.last_name}`;
  }
}
